import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'card-list',
  name: '卡片列表',
  icon: '卡',
  group: '数据组件',
  description: '展示支持网格、瀑布流、分页和空态的卡片列表',
  defaultProps: {
    layoutMode: 'GRID',
    columns: 2,
    pageSize: 12,
    emptyText: '暂无数据',
    items: []
  }
}
